// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Fa-V","box":"WorkspacesBox_box__18yfZ","node":"WorkspacesBox_node__2NzHA"};